import { Component, OnInit, ViewChild } from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DataService } from 'src/app/services/data.service';
import { NotifierService } from 'angular-notifier';
import { MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import{ ConfirmListadoIniciativasAdminComponent} from 'src/app/components/shared/confirm-listado-iniciativas-admin/confirm-listado-iniciativas-admin.component';

//Interface para los catalogos de areas
export interface Area {
  id_area: number;
  nombre_area:string;
  estatus_area:boolean;
}

export interface Aplicaciones {
  estatus_aplicacion:boolean;
  id_aplicacion: number;
  id_area:number;
  nombre_aplicacion:string;
}


@Component({
  selector: 'app-aplicaciones',
  templateUrl: './aplicaciones.component.html',
  styleUrls: ['./aplicaciones.component.css']
})
export class AplicacionesComponent implements OnInit {

  displayedColumns: string[] = ['Nombre','Acciones'];

  @ViewChild('TablaAreas', {static: false}) paginatorArea: MatPaginator;
  @ViewChild('TablaAreaSort', {static: false}) sortSub: MatSort;

  
  //Tabla area-aplicacion
  @ViewChild('TablaAreaApp', {static: false}) paginatorAreaApp: MatPaginator;
  @ViewChild('TablaAreaAppSort', {static: false}) sortAreaApp: MatSort;


  @ViewChild('TablaAplicacion', {static: false}) paginatorApp: MatPaginator;
  @ViewChild('TablaAplicacionSort', {static: false}) sortApp: MatSort;

  dataSource:any;
  nombreArea:string;
  //Lista de areas
  listaAreas:Area[]=[];
  listaAreasApp:Area[]=[];

  loadingArea:boolean=false;

  dataSourceApp:any;
  listaAplicaciones:Aplicaciones[]=[];
  listaAplicacionesSA:Aplicaciones[]=[];
  listaAplicacionesData:Aplicaciones[]=[];

  nombreApp:string;
  loadingApp:boolean=false;
  selectedValueArea:number;

  dataSourceAreaApp:any;
  selectedValueApp:number;
  loadingGeneral:boolean=false;
  loading:boolean=false;


  constructor(
    private dataService: DataService,
    public dialog:MatDialog,
    private notifier: NotifierService) { 
    this.dataSource= new MatTableDataSource;
    this.dataSourceApp= new MatTableDataSource;
    this.dataSourceAreaApp= new MatTableDataSource;    
  }

  ngOnInit(): void {
    this.cargarAreas();
    this.cargarAplicaciones();
    this.cargarAplicacionesSinArea();
  }

  ngAfterViewInit() {
  }


  //Método para cargar las áreas dueñas
  cargarAreas()
  {
    this.dataService.obtenerGruposSistemas().subscribe(
      data => {
        this.listaAreas = data['data'];
        this.listaAreasApp= data['data'];
        this.dataSource.data = this.listaAreas;
        this.dataSource.paginator=this.paginatorArea;
      },
      error => {
        console.error(error);       
      }
    );

  }

  //Filtro para las areas dueñas
  applyFilterArea(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  //Método para agregar las areas 
  agregarArea()
  {
    this.loadingArea=true;
    this.dataService.insertArea(this.nombreArea).subscribe(
      data => {
        if (data['objData']) 
        {
          this.notifier.notify(
            'success',
            'Se agrego correctamente.'
          );
          this.nombreArea="";
          this.cargarAreas();
          this.loadingArea=false;
        }
        else{
          this.notifier.notify('error',data['errorMessage']);
          this.loadingArea=false;
        }
      },
      error => {
        console.error(error);
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar agregar el área. Verifique su conexión de red o contacte al administrador.'
        );
      }
    );

  }

  //Método para eliminar área dueña
  eliminarArea(id:number)
  {
    
    //Mostramos la ventana de confirmación
    let dialogRef = this.dialog.open(ConfirmListadoIniciativasAdminComponent,{data:{opcion:27},disableClose:true});
    dialogRef.afterClosed().subscribe(result => {
      if(result==false)
      {
      }
      else{
        this.loadingArea=true;
      this.dataService.deleteArea(id).subscribe(
         data => {
           if (data['objData']) 
           {
             this.notifier.notify(
               'success',
               'Se elimino correctamente.'
             );
             this.cargarAreas();
              this.loadingArea=false;

           }
           else{
             this.notifier.notify('error',data['errorMessage']);
           }
         },
         error => {
           console.error(error);
           this.notifier.notify(
             'error',
             'Ha ocurrido un error al intentar eliminar el área. Verifique su conexión de red o contacte al administrador.'
           );
         }
       );

      }
  }); 

  }

  //Método para editar area
  editarArea(id_area:number)
  {
    let dialogRef = this.dialog.open(ConfirmListadoIniciativasAdminComponent,{data:{id:id_area,opcion:26,titulo:"Editar área dueña",etiqueta:"Nombre área"},disableClose:true});
    dialogRef.afterClosed().subscribe(result => {
      if(result==false)
      {
      }
      else{
        this.loadingArea=true;
        let valores={
          'id_area':id_area,
          'nombre_area':result,
        }
       this.dataService.updateArea(valores).subscribe(
         data => {
           if (data['objData']) 
           {
             this.notifier.notify(
               'success',
               'Se edito correctamente.'
             );
             this.cargarAreas();
             this.loadingArea=false;
           }
           else{
             this.notifier.notify('error',data['errorMessage']);
           }
         },
         error => {
           console.error(error);
           this.notifier.notify(
             'error',
             'Ha ocurrido un error al intentar editar el área. Verifique su conexión de red o contacte al administrador.'
           );
         }
       );

      }
  });  

  }


  /***********************************************************************/
  //Método para cargar las aplicaciones
  cargarAplicaciones()
  {
    this.dataService.getListAplicaciones().subscribe(
      data => {
        this.listaAplicaciones = data['data'];
        this.dataSourceApp.data = this.listaAplicaciones;
         this.dataSourceApp.paginator=this.paginatorApp;
      },
      error => {
        console.error(error);       
      }
    );

  }

  //Método para filtrar las aplicaciones
  applyFilterAplicacion(filterValue: string){
    this.dataSourceApp.filter = filterValue.trim().toLowerCase();

  }

  agregarApp()
  {
    this.loadingApp=true;
    this.dataService.insertApp(this.nombreApp).subscribe(
      data => {
        if (data['objData']) 
        {
          this.notifier.notify(
            'success',
            'Se agrego correctamente.'
          );
          this.nombreApp="";
          this.cargarAplicaciones();
          this.cargarAplicacionesSinArea();
          this.loadingApp=false;
        }
        else{
          this.notifier.notify('error',data['errorMessage']);
          this.loadingApp=false;
        }
      },
      error => {
        console.error(error);
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar agregar la aplicación. Verifique su conexión de red o contacte al administrador.'
        );
      }
    );

  }


  //Método para eliminar aplicación
  eliminarApp(id:number)
  {
    //Mostramos la ventana de confirmación
    let dialogRef = this.dialog.open(ConfirmListadoIniciativasAdminComponent,{data:{opcion:27},disableClose:true});
    dialogRef.afterClosed().subscribe(result => {
      if(result==false)
      {
      }
      else{
        this.loadingApp=true;
      this.dataService.deleteApp(id).subscribe(
         data => {
           if (data['objData']) 
           {
             this.notifier.notify(
               'success',
               'Se elimino correctamente.'
             );
             this.cargarAplicaciones();
              this.loadingApp=false;
           }
           else{
             this.notifier.notify('error',data['errorMessage']);
           }
         },
         error => {
           console.error(error);
           this.notifier.notify(
             'error',
             'Ha ocurrido un error al intentar eliminar la aplicación. Verifique su conexión de red o contacte al administrador.'
           );
         }
       );

      }
  }); 

  }

  //Método para editar aplicacion
  modificarApp(id:number)
  {
    let dialogRef = this.dialog.open(ConfirmListadoIniciativasAdminComponent,{data:{id:id,opcion:28,titulo:"Editar aplicación",etiqueta:"Nombre aplicación"},disableClose:true});
    dialogRef.afterClosed().subscribe(result => {
      if(result==false)
      {
      }
      else{
        this.loadingApp=true;
        let valores={
          'id_aplicacion':id,
          'nombre_aplicacion':result,
        }
       this.dataService.updateAplicacion(valores).subscribe(
         data => {
           if (data['objData']) 
           {
             this.notifier.notify(
               'success',
               'Se edito correctamente.'
             );
             this.cargarAplicaciones();
             this.loadingApp=false;
           }
           else{
             this.notifier.notify('error',data['errorMessage']);
           }
         },
         error => {
           console.error(error);
           this.notifier.notify(
             'error',
             'Ha ocurrido un error al intentar editar el área. Verifique su conexión de red o contacte al administrador.'
           );
         }
       );

      }
  });  

  }


  /***********************************************************************/
  onChange(idArea: number) 
  {
    this.dataService.getAplicacionesByArea(idArea).subscribe(
      data => {
        if (data['data']) 
        {
          this.listaAplicacionesData = data['data'];
          this.dataSourceAreaApp.data=this.listaAplicacionesData;
          this.dataSourceAreaApp.paginator=this.paginatorAreaApp;
        }
      },
      error => {
        console.log(error);
      }
    );
  }

   //Método para cargar las aplicaciones
   cargarAplicacionesSinArea()
   {
     this.dataService.getListAplicacionSinArea().subscribe(
       data => {
         this.listaAplicacionesSA = data['data'];
       },
       error => {
         console.error(error);       
       }
     );
 
   }

   //Agregar relación area/aplicacion 
   AgregarAreaApp(app:number,area:number)
   {
     
    this.loadingGeneral=true;
    this.dataService.insertUpdateAreaApp(app,area).subscribe(
      data => {
        if (data['objData']) 
        {
          this.notifier.notify(
            'success',
            'Se agrego correctamente.'
          );
          this.selectedValueApp=null;
          this.selectedValueArea=null;
          this.onChange(area);
          this.loadingGeneral=false;
        }
        else{
          this.notifier.notify('error',data['errorMessage']);
          this.loadingGeneral=false;
        }
      },
      error => {
        console.error(error);
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar agregar la aplicación. Verifique su conexión de red o contacte al administrador.'
        );
      }
    );

   }


   //Modificar relacion area/app
   updateAreaApp(app:number,area:number)
   {
    let dialogRef = this.dialog.open(ConfirmListadoIniciativasAdminComponent,{data:{id:app,opcion:29,idArea:this.selectedValueArea,titulo:"Editar Área-Aplicación",etiqueta:"Dirección general"},disableClose:true, width: '600px'});
    dialogRef.afterClosed().subscribe(result => {
      if(result==false)
      {
      }
      else{
       this.loadingGeneral=true;
       this.dataService.insertUpdateAreaApp(app,result).subscribe(
         data => {
           if (data['objData']) 
           {
             this.notifier.notify(
               'success',
               'Se edito correctamente.'
             );
             this.onChange(this.selectedValueArea);
             this.loadingGeneral=false;
           }
           else{
             this.notifier.notify('error',data['errorMessage']);
             this.loadingGeneral=false;
           }
         },
         error => {
           console.error(error);
           this.notifier.notify(
             'error',
             'Ha ocurrido un error al intentar editar el área. Verifique su conexión de red o contacte al administrador.'
           );
         }
       );

      }
  });

   }

   //Eliminar relacion area/app
   eliminarAreaApp(idApp:number){
     //Mostramos la ventana de confirmación
    let dialogRef = this.dialog.open(ConfirmListadoIniciativasAdminComponent,{data:{opcion:27},disableClose:true});
    dialogRef.afterClosed().subscribe(result => {
      if(result==false)
      {
      }
      else{
        this.loadingGeneral=true;
       this.dataService.deleteAreaApp(idApp).subscribe(
         data => {
           if (data['objData']) 
           {
             this.notifier.notify(
               'success',
               'Se elimino correctamente.'
             );
             this.onChange(this.selectedValueArea);
             this.cargarAplicaciones();
             this.loadingGeneral=false;
           }
           else{
             this.notifier.notify('error',data['errorMessage']);
           }
         },
         error => {
           console.error(error);
           this.notifier.notify(
             'error',
             'Ha ocurrido un error al intentar eliminar la aplicación. Verifique su conexión de red o contacte al administrador.'
           );
         }
       );

      }
  }); 


   }

   quitarFiltro(){
     this.selectedValueApp=null;
     this.selectedValueArea=null;
     this.dataSourceAreaApp.data=[];
   }

}
